import {Injectable} from '@angular/core';
import * as Handlebars from 'handlebars';

// import { LocationDataProcessingService } from './location-data-processing.service';

@Injectable({
  providedIn: 'root'
})
export class HandlebarsService {
  constructor() {
    Handlebars.registerHelper('formatSpecialties', function(specialtiesV2) {
      return JSON.stringify(specialtiesV2, null, 4); // Formats with newlines and indentation
    });

    Handlebars.registerHelper('addressLineJoin', function (array: string[], separator: string = ', ') {
      if (!Array.isArray(array)) return '';
      return array.join(separator);
    });

    // to check equality
    Handlebars.registerHelper('eq', function(a, b) {
      return a === b;
    });
  }

  compileTemplate(source: string, context: any): string {
    const template = Handlebars.compile(source);

    return template(context);
  }

}
